import { ApiResult } from 'src/Libs/api'
import { ShopAuthFetchWithResponse } from '../types'
import { FavoriteSystemResponse, SaveConfiguratorResponse } from '../models'
import { StatusCodes } from '@e3dc-react/shell/Libs/http-status-codes'
import { FavoriteConfiguratorDto } from './dto/save-configurator.dto'
import { ShopSystemConfiguration } from 'src/State/ShopSystemConfiguration/ShopSystemConfigurationModel'
import systemConfigurationFromModelToDtoTransformer from './transformer/save-configuration-from-model-to-dto.transformer'

/*
 * This endpoint will return all  customer or company saved system configurators
 */
export const fetchAllSavedConfigurators = async (shopFetch: ShopAuthFetchWithResponse): Promise<ApiResult<FavoriteSystemResponse>> => {
  const payload = {}

  try {
    const response = await shopFetch<FavoriteSystemResponse>({
      path: 'e3dc/system-configurations',
      method: 'GET',
      criteria: payload,
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<FavoriteSystemResponse>(response.data, true)
    }

    return new ApiResult<FavoriteSystemResponse>(null)
  } catch (error) {
    return new ApiResult<FavoriteSystemResponse>(null)
  }
}

/*
 * This endpoint will save the configurator that will be passed
 */
export const saveConfigurator = async (
  configurator: ShopSystemConfiguration,
  shopFetch: ShopAuthFetchWithResponse
): Promise<ApiResult<SaveConfiguratorResponse>> => {
  try {
    const response = await shopFetch<SaveConfiguratorResponse>({
      path: 'e3dc/system-configuration',
      method: 'POST',
      payload: systemConfigurationFromModelToDtoTransformer(configurator),
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<SaveConfiguratorResponse>(response.data, true)
    }

    return new ApiResult<SaveConfiguratorResponse>(null)
  } catch (error) {
    return new ApiResult<SaveConfiguratorResponse>(null)
  }
}

/*
 * This endpoint will delete the configurator for the customer or company.
 */
export const deleteConfigurator = async (
  configuratorId: string,
  shopFetch: ShopAuthFetchWithResponse
): Promise<ApiResult<SaveConfiguratorResponse>> => {
  try {
    const response = await shopFetch<SaveConfiguratorResponse>({
      path: `e3dc/system-configuration/${configuratorId}`,
      method: 'DELETE',
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<SaveConfiguratorResponse>(response.data, true)
    }

    return new ApiResult<SaveConfiguratorResponse>(null)
  } catch (error) {
    return new ApiResult<SaveConfiguratorResponse>(null)
  }
}

/*
 * This endpoint will update an existing configurator with the new configurator
 */
export const updateConfigurator = async (
  configuratorId: string,
  configurator: ShopSystemConfiguration,
  shopFetch: ShopAuthFetchWithResponse
): Promise<ApiResult<SaveConfiguratorResponse>> => {
  try {
    const response = await shopFetch<SaveConfiguratorResponse>({
      path: `e3dc/system-configuration/${configuratorId}`,
      method: 'PATCH',
      payload: systemConfigurationFromModelToDtoTransformer(configurator),
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<SaveConfiguratorResponse>(response.data, true)
    }

    return new ApiResult<SaveConfiguratorResponse>(null)
  } catch (error) {
    return new ApiResult<SaveConfiguratorResponse>(null)
  }
}

/*
 *This endpoint will get single configurator
 */
export const getSingleConfigurator = async (
  configuratorId: string,
  shopFetch: ShopAuthFetchWithResponse
): Promise<ApiResult<FavoriteConfiguratorDto>> => {
  try {
    const response = await shopFetch<FavoriteConfiguratorDto>({
      path: `e3dc/system-configuration/${configuratorId}`,
      method: 'GET',
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<FavoriteConfiguratorDto>(response.data, true)
    }

    return new ApiResult<FavoriteConfiguratorDto>(null)
  } catch (error) {
    return new ApiResult<FavoriteConfiguratorDto>(null)
  }
}
